type IFontFamilyKey = "light" | "regular" | "subtitle" | "title" | "granville";

const fontFamily: { [key in IFontFamilyKey]: string } = {
  light: "FuturaPTLight",
  regular: "FuturaPTBook",
  subtitle: "FuturaPTMedium",
  title: "PlayfairDisplay",
  granville: "Granville, FuturaPTMedium, Futura, Arial, sans-serif",
};

export default {
  ...fontFamily,
};
